define('OutSystems/ReactView/findRouteMatch',["require", "exports", "tslib", "query-string", "react-router-dom"], function (require, exports, tslib_1, querystring, react_router_dom_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function removeUnmatchedParams(paramMap) {
        return Object.keys(paramMap)
            .filter(function (key) { return paramMap[key] !== null && paramMap[key] !== undefined; })
            .reduce(function (obj, key) {
            obj[key] = paramMap[key];
            return obj;
        }, {});
    }
    function removeUnnamedParams(paramMap) {
        return Object.keys(paramMap)
            .filter(function (key) { return isNaN(Number(key)); })
            .reduce(function (obj, key) {
            obj[key] = paramMap[key];
            return obj;
        }, {});
    }
    function decodeURIParams(paramMap) {
        return Object.keys(paramMap).reduce(function (obj, key) {
            obj[key] = decodeURIComponent(paramMap[key]);
            return obj;
        }, {});
    }
    function buildParamMap(matchedParams, search) {
        if (matchedParams === void 0) { matchedParams = {}; }
        if (search === void 0) { search = ""; }
        var fixedParams = removeUnnamedParams(removeUnmatchedParams(matchedParams));
        var decodedURIParams = decodeURIParams(fixedParams);
        var searchParams = querystring.parse(search);
        return tslib_1.__assign(tslib_1.__assign({}, searchParams), decodedURIParams);
    }
    function findRouteMatch(routeInfos, location) {
        if (!routeInfos || !location) {
            return null;
        }
        var routeMatch = null;
        routeInfos.some(function (routeInfo) {
            if (!routeInfo) {
                return false;
            }
            var match = react_router_dom_1.matchPath(location.pathname, { path: routeInfo.pathname, exact: true });
            if (match && !routeMatch) {
                routeMatch = {
                    routeInfo: routeInfo,
                    matchedParams: buildParamMap(match.params, location.search),
                };
                return true;
            }
            return false;
        });
        return routeMatch;
    }
    exports.default = findRouteMatch;
});
//# sourceMappingURL=findRouteMatch.js.map;
